import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccdc01a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "latex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "a", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "e", -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createTextVNode("L"),
    _hoisted_2,
    _createTextVNode("T"),
    _hoisted_3,
    _createTextVNode("X")
  ]))
}